import omit from 'lodash/omit'

export const MediumIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height="14"
    viewBox="0 0 24 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...omit(props, 'fill')}
  >
    <path
      d="M13.5375 7.00001C13.5375 10.7275 10.5075 13.75 6.768 13.75C5.8804 13.7512 5.00125 13.5775 4.18076 13.239C3.36026 12.9004 2.61449 12.4035 1.98603 11.7767C1.35756 11.1499 0.858704 10.4055 0.517941 9.58588C0.177178 8.76629 0.00118111 7.88761 0 7.00001C0 3.27101 3.03 0.250008 6.768 0.250008C7.65573 0.248628 8.53504 0.422139 9.3557 0.76063C10.1764 1.09912 10.9223 1.59596 11.5509 2.22278C12.1796 2.84959 12.6786 3.5941 13.0194 4.41379C13.3603 5.23347 13.5363 6.11228 13.5375 7.00001ZM20.9625 7.00001C20.9625 10.51 19.4475 13.354 17.5785 13.354C15.7095 13.354 14.1945 10.5085 14.1945 7.00001C14.1945 3.49001 15.7095 0.646008 17.5785 0.646008C19.4475 0.646008 20.9625 3.49151 20.9625 7.00001ZM24 7.00001C24 10.144 23.4675 12.6925 22.809 12.6925C22.152 12.6925 21.6195 10.1425 21.6195 7.00001C21.6195 3.85601 22.152 1.30751 22.8105 1.30751C23.4675 1.30751 24 3.85601 24 7.00001Z"
      fill={props.fill || '#350174'}
    />
  </svg>
)
